// extracted by mini-css-extract-plugin
export default {"title":"_1_IHb___Listings-module__title","cardList":"_3C1R-___Listings-module__cardList"};